import React from "react";

const OurExpertise = () => {
  return (
    <section id="services" className="relative bg-black text-white px-6 py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 relative">
        {/* Left Content */}
        <div className="flex flex-col justify-start">
          {/* Title and Description */}
          <div className="mb-12">
            <h2 className="text-4xl font-bold mb-6">Our Expertise Includes</h2>
            <p className="text-lg text-gray-400 pb-12 leading-relaxed">
              Our dynamic team of experts is dedicated to transforming ideas into reality.
            </p>
          </div>

          {/* Two Boxes Below Text */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {[{ title: "IT Consulting", icon: "🔧" }, { title: "Dynamic Approach for Dev Work Flow", icon: "⚙️" }].map(
              (item, index) => (
                <div
                  key={index}
                  className="bg-gray-900 p-4 rounded-lg shadow-lg flex items-center space-x-4 w-full h-40 transition-all duration-300 transform hover:-translate-y-2 hover:bg-white hover:shadow-2xl hover:shadow-green-400 hover:text-black"
                >
                  <div className="text-green-500 text-4xl">{item.icon}</div>
                  <p className="text-sm font-medium">{item.title}</p>
                </div>
              )
            )}
          </div>
        </div>

        {/* Right Content (2x2 Grid in Desktop View) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 relative z-10">
          {[
            { title: "Mobile application Development", icon: "📱" },
            { title: "Website design & Development", icon: "💻" },
            { title: "Custom Software Solutions", icon: "🛠️" },
            { title: "Software Documentation", icon: "📄" },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-gray-900 p-4 rounded-lg shadow-lg flex items-center space-x-4 w-full h-40 transition-all duration-300 transform hover:-translate-y-2 hover:bg-white hover:shadow-2xl hover:shadow-green-400 hover:text-black"
            >
              <div className="text-green-500 text-4xl">{item.icon}</div>
              <p className="text-sm font-medium">{item.title}</p>
            </div>
          ))}
        </div>

        {/* Decorative Lines and Dots */}
        <div className="absolute top-0 right-5 transform -translate-x-10 -translate-y-10 z-0">
          {/* Larger Lines */}
          <div className="w-[300px] h-[300px] border-[2px] border-gray-600 rounded-full absolute"></div>
          <div className="w-[500px] h-[500px] border-[2px] border-gray-600 rounded-full absolute top-10 left-10"></div>
          <div className="w-[700px] h-[700px] border-[2px] border-gray-600 rounded-full absolute top-20 left-20"></div>

          {/* Smaller Dots */}
          <div className="absolute w-1.5 h-1.5 bg-blue-500 rounded-full top-10 left-20"></div>
          <div className="absolute w-1.5 h-1.5 bg-purple-500 rounded-full bottom-5 right-10"></div>
          <div className="absolute w-1.5 h-1.5 bg-green-500 rounded-full top-20 right-5"></div>
        </div>
      </div>
    </section>
  );
};

export default OurExpertise;
